// 01/07 — Bilan « dynamique groupe » : fonctions support recrutées,
// investissements groupe actifs et impacts chiffrés sur le réseau.
// Consommé par le PDF de débrief et la télémétrie superviseur.
import { SUPPORT_ROLES } from '../data/supportRoles';
import { INVESTMENTS } from '../data/investments';

const GRP_IDS = ['inv-office-01', 'grp-centrale', 'grp-erp', 'grp-logistique', 'grp-academie'];

export const bilanGroupe = (state) => {
  const hired = state?.hiredSupport || {};
  const inv = state?.activeInvestments || {};
  const roles = SUPPORT_ROLES.filter(r => hired[r.id]);
  const invests = GRP_IDS.filter(id => inv[id])
    .map(id => INVESTMENTS.find(i => i.id === id))
    .filter(Boolean);
  if (roles.length === 0 && invests.length === 0) return null;
  const sum = (type) => roles.reduce((s, r) =>
    s + (r.bonuses || []).filter(b => b.type === type).reduce((a, b) => a + b.value, 0), 0);
  const fiabBase = Math.max(0.2, (1 - Math.min(0.5, sum('fiabilite_fournisseur'))) * (inv['grp-logistique'] ? 0.5 : 1));
  return {
    siege: !!inv['inv-office-01'],
    invests: invests.map(i => ({ id: i.id, nom: i.name, chargeMonthly: i.chargeMonthly || 0 })),
    fonctions: roles.map(r => ({ nom: r.name, role: r.role, cout: r.monthlyCost })),
    coutMensuel: roles.reduce((s, r) => s + r.monthlyCost, 0) + invests.reduce((s, i) => s + (i.chargeMonthly || 0), 0),
    caPct: Math.round((sum('revenue') + (inv['grp-erp'] ? 0.05 : 0)) * 100),
    achatPct: Math.round(Math.min(0.12, sum('achat_discount') + (inv['grp-centrale'] ? 0.03 : 0)) * 100),
    massePct: Math.round(Math.min(0.2, sum('masse_salariale_discount')) * 100),
    fiabilitePct: Math.round((1 - fiabBase) * 100),
    satMois: Math.round((sum('satisfaction_passive') + (inv['grp-academie'] ? 3 : 0)) * 10) / 10,
  };
};
